<template>
  <thead class="bg-orange-200/30">
    <tr
      v-if="!expanded"
      class="first-child:pl-3 last-child:pr-3 child:py-2 text-xs child:border-b child:border-gray-200 font-semibold text-gray-600 uppercase tracking-wider"
    >
      <th class="" />

      <th class="text-right pr-3">
        Final Amount
      </th>

      <th />

      <th />

      <th />

      <th />

      <th v-if="showPercentages" />

      <th v-if="showPercentages" />

      <th v-if="showPercentages" />

      <th v-if="showForecasts" />

      <th v-if="ratesColumn" />

      <th />

      <th />

      <th class="text-right pr-3" />

      <th class="text-right pr-3">
        Current Forecast
      </th>
    </tr>

    <tr
      class="first-child:pl-3 last-child:pr-3 child:py-3 cursor-pointer child:border-b child:border-gray-200"
      @click="expanded = !expanded"
    >
      <th class="text-left font-semibold text-gray-700 tracking-wider">
        <div class="flex items-center space-x-2">
          <button
            type="button"
            class="btn-icon btn-icon-default"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 transition-transform"
              :class="{ 'rotate-90': expanded }">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
          </button>

          <div
            v-if="canEditMonth && expanded"
            class="flex items-center justify-end gap-1"
          >
            <button
              type="button"
              class="btn-icon btn-icon-default"
              title="Add category"
              @click.stop="addDraftCategoryRow"
            >
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    />
</svg>
            </button>

            <button
              type="button"
              class="btn-icon btn-icon-default"
              title="Add scope gap item"
              @click.stop="addDraftRow"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>
            </button>
          </div>


          <span>Scope Gap</span>
        </div>
      </th>

      <th class="text-right font-semibold text-gray-900 normal-case tracking-normal pr-3">
        <p>
          {{ australianCurrency(totals.finalAmount) }}
        </p>

        <div class="font-normal normal-case">
          {{ australianCurrency(packageTotal + totals.finalAmount) }}
        </div>
      </th>

      <th />

      <th />

      <th />

      <th />

      <th v-if="showPercentages" />

      <th v-if="showPercentages" />

      <th v-if="showPercentages" />

      <th v-if="showForecasts" />

      <th v-if="ratesColumn" />

      <th class="" />

      <th />

      <th />

      <th class="text-right text-gray-900 normal-case tracking-normal pr-3">
        <p class="font-semibold">
          {{ australianCurrency(totals.currentForecast) }}
        </p>

        <p class="font-normal normal-case">
          {{ australianCurrency(totals.currentForecast + actualForecastSum) }}
        </p>

        <p
          class="text-xs"
          :class="totalsVarianceClass"
        >
          {{ australianCurrency(totals.variance) }} m-1
        </p>
      </th>
    </tr>

    <tr
      v-if="expanded"
      class="first-child:pl-3 last-child:pr-3 child:py-2 text-xs child:border-b child:border-gray-200 font-semibold text-gray-600 uppercase tracking-wider"
    >
      <th class="text-left">
        Description
      </th>

      <th class="text-right pr-3">
        Final Amount
      </th>

      <th />

      <th />

      <th />

      <th />

      <th v-if="showPercentages" />

      <th v-if="showPercentages" />

      <th v-if="showPercentages" />

      <th v-if="showForecasts" />

      <th v-if="ratesColumn" />

      <th />

      <th />

      <th class="text-right pr-3">
        Forecast Percent
      </th>

      <th class="text-right pr-3">
        Current Forecast
      </th>
    </tr>
  </thead>


  <template v-if="expanded && scopeGap">
    <Sortable
      v-if="categories.length"
      :list="categories"
      item-key="id"
      tag="template"
      class="contents relative"
      :class="{ 'opacity-50 pointer-events-none': updateCategorySortAction.is(States.LOADING) }"
      :disabled="!canEditMonth"
      :options="{
        handle: '.scope-gap-category-drag-handle'
      }"
      @end="onCategorySortEnd"
    >
      <template
        v-if="updateCategorySortAction.is(States.LOADING)"
        #header
      >
        <tbody>
          <tr>
            <td :colspan="10 + (showPercentages ? 3 : 0) + (showForecasts ? 1 : 0)">
              <div class="flex justify-center py-2">
                <AppSpinner />
              </div>
            </td>
          </tr>
        </tbody>
      </template>

      <template #item="{ element }">
        <ScopeGapCategoryRow
          :scope-gap="scopeGap"
          :previous-scope-gap="previousScopeGap"
          :category="element"
          :can-edit="canEditMonth"
          :show-drag-handle="canEditMonth"
          :show-percentages="showPercentages"
          :show-forecasts="showForecasts"
          :rates-column="ratesColumn"
          @refresh-data="loadData"
        />
      </template>
    </Sortable>

    <template v-if="categories.length && localUncategorizedForecasts.length">
      <tr
        class="bg-orange-200/30 text-sm child:py-3 first-child:pl-3 last-child:pr-3 child:border-b child:border-gray-200 cursor-pointer"
        @click="uncategorizedExpanded = !uncategorizedExpanded"
      >
        <td class="text-left font-semibold text-gray-700">
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="btn-icon btn-icon-default"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 transition-transform"
                :class="{ 'rotate-90': uncategorizedExpanded }">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
            </button>

            <span>
              Uncategorised
            </span>
          </div>
        </td>

        <td class="text-right font-semibold text-gray-900 content-center pr-3">
          {{ australianCurrency(uncategorizedTotals.finalAmount) }}
        </td>

        <td />

        <td />

        <td />

        <td />

        <td v-if="showPercentages" />

        <td v-if="showPercentages" />

        <td v-if="showPercentages" />

        <td v-if="showForecasts" />

        <td v-if="ratesColumn" />

        <td />

        <td />

        <td />

        <td class="text-right font-semibold text-gray-900 content-center pr-3">
          <p>
            {{ australianCurrency(uncategorizedTotals.currentForecast) }}
          </p>

          <p
            class="text-xs"
            :class="uncategorizedTotalsVarianceClass"
          >
            {{ australianCurrency(uncategorizedTotals.variance) }} m-1
          </p>
        </td>
      </tr>

      <Sortable
        v-if="uncategorizedExpanded && localUncategorizedForecasts.length"
        :list="localUncategorizedForecasts"
        item-key="id"
        tag="template"
        class="divide-y divide-gray-200 relative contents"
        :class="{ 'opacity-50 pointer-events-none': updateItemSortAction.is(States.LOADING) }"
        :disabled="!canEditMonth"
        :options="{
          handle: '.scope-gap-item-drag-handle'
        }"
        @end="onItemSortEnd"
      >
        <template #item="{ element: monthlyForecast }">
          <ScopeGapItemRow
            :scope-gap-item="monthlyForecast.scope_gap_item"
            :current-forecast="monthlyForecast"
            :previous-forecast="monthlyForecast.scope_gap_item.monthly_forecasts.length > 0 ? monthlyForecast.scope_gap_item.monthly_forecasts[0] : undefined"
            :can-edit="canEditMonth"
            :show-drag-handle="canEditMonth"
            :show-percentages="showPercentages"
            :show-forecasts="showForecasts"
            :rates-column="ratesColumn"
            @refresh="loadData"
          />
        </template>
      </Sortable>
    </template>

    <Sortable
      v-else-if="!categories.length && hasScopeGapItems"
      :list="localFlatForecasts"
      item-key="id"
      tag="tbody"
      class="bg-orange-200/30 divide-y divide-gray-200 relative"
      :class="{ 'opacity-50 pointer-events-none': updateItemSortAction.is(States.LOADING) }"
      :disabled="!canEditMonth"
      :options="{
        handle: '.scope-gap-item-drag-handle'
      }"
      @end="onItemSortEnd"
    >
      <template
        v-if="updateItemSortAction.is(States.LOADING)"
        #header
      >
        <tr>
          <td :colspan="10 + (showPercentages ? 3 : 0) + (showForecasts ? 1 : 0)">
            <div class="flex justify-center py-2">
              <AppSpinner />
            </div>
          </td>
        </tr>
      </template>

      <template #item="{ element: monthlyForecast }">
        <ScopeGapItemRow
          :scope-gap-item="monthlyForecast.scope_gap_item"
          :current-forecast="monthlyForecast"
          :previous-forecast="monthlyForecast.scope_gap_item.monthly_forecasts.length > 0 ? monthlyForecast.scope_gap_item.monthly_forecasts[0] : undefined"
          :can-edit="canEditMonth"
          :show-drag-handle="canEditMonth"
          :show-percentages="showPercentages"
          :show-forecasts="showForecasts"
          :rates-column="ratesColumn"
          @refresh="loadData"
        />
      </template>
    </Sortable>

    <tbody v-if="showEmptyState">
      <tr class="bg-orange-200/30">
        <td
          colspan="100%"
          class="text-center p-4 text-gray-500"
        >
          No scope gap items
        </td>
      </tr>
    </tbody>

    <tbody>
      <ScopeGapDraftCategoryRow
        v-for="draftCategoryKey in draftCategoryKeys"
        :key="draftCategoryKey"
        :project-id="projectId"
        :package-id="packageId"
        :can-edit="canEditMonth"
        :show-percentages="showPercentages"
        :show-forecasts="showForecasts"
        :rates-column="ratesColumn"
        @saved="onDraftCategorySaved(draftCategoryKey)"
        @removed="removeDraftCategoryRow(draftCategoryKey)"
      />

      <ScopeGapDraftItemRow
        v-for="draftKey in draftRowKeys"
        :key="draftKey"
        :project-id="projectId"
        :package-id="packageId"
        :can-edit="canEditMonth"
        :show-percentages="showPercentages"
        :show-forecasts="showForecasts"
        :rates-column="ratesColumn"
        @saved="onDraftSaved(draftKey)"
        @removed="removeDraftRow(draftKey)"
      />
    </tbody>
  </template>
</template>

<script setup lang="ts">
import ScopeGapCategoryRow from '@/components/Subcontract/SubcontractorClaimShow/ScopeGapCategoryRow.vue';
import ScopeGapDraftCategoryRow from '@/components/Subcontract/SubcontractorClaimShow/ScopeGapDraftCategoryRow.vue';
import ScopeGapDraftItemRow from '@/components/Subcontract/SubcontractorClaimShow/ScopeGapDraftItemRow.vue';
import ScopeGapItemRow from '@/components/Subcontract/SubcontractorClaimShow/ScopeGapItemRow.vue';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency } from '@/helpers';
import MonthlyScopeGapForecast from '@/models/MonthlyScopeGapForecast';
import ScopeGapCategory from '@/models/ScopeGapCategory';
import { useMonthlyScopeGapForecastsStore } from '@/store/monthlyScopeGapForecasts';
import { useScopeGapCategoriesStore } from '@/store/scopeGapCategories';
import { useScopeGapItemsStore } from '@/store/scopeGapItems';
import { useScopeGapsStore } from '@/store/scopeGaps';
import { DateTime } from 'luxon';
import { Sortable } from 'sortablejs-vue3';
import { computed, nextTick, ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    scopeGapId: Id;
    projectId: string;
    packageId: string;
    canEdit: boolean;
    packageTotal: number;
    showPercentages?: boolean;
    showForecasts?: boolean;
    ratesColumn?: boolean;
    actualForecastSum: number;
  }>(),
  {
    showPercentages: false,
    showForecasts: false,
    ratesColumn: false,
  },
);

const emits = defineEmits<{
  (e: 'draftAdded'): void;
}>();

const scopeGapsStore = useScopeGapsStore();
const scopeGapItemsStore = useScopeGapItemsStore();
const scopeGapCategoriesStore = useScopeGapCategoriesStore();
const monthlyScopeGapForecastsStore = useMonthlyScopeGapForecastsStore();
const fetchScopeGapShowAction = useStoreApiAction(scopeGapsStore.show);
const updateCategorySortAction = useStoreApiAction(scopeGapCategoriesStore.sort);
const updateItemSortAction = useStoreApiAction(monthlyScopeGapForecastsStore.sort);
const expanded = ref(false);
const draftRowKeys = ref<string[]>([]);
const draftCategoryKeys = ref<string[]>([]);
let draftKeyCounter = 0;
let draftCategoryKeyCounter = 0;

watch(() => props.scopeGapId, () => {
  loadData();
}, { immediate: true });

async function loadData() {
  console.trace('loading data');

  if(!props.scopeGapId) return;

  await fetchScopeGapShowAction.request(props.scopeGapId);
}

const scopeGap = computed(() => {
  return scopeGapsStore.models
    .with('monthly_forecasts', (query) => {
      query.with('scope_gap_item', (query) => {
        query.with('monthly_forecasts', (query) => {
          query.where('scope_gap_id', previousScopeGap.value?.id);
        });
      });
    })
    .with('categories', (query) => {
      query.orderBy('sort_order');
    })
    .find(props.scopeGapId);
});

const previousScopeGap = computed(() => {
  return scopeGapsStore.models
    .orderBy('sort_order', 'desc')
    .where('sort_order', (sort_order) => sort_order < scopeGap.value?.sort_order)
    .first();
});

const categories = computed(() => {
  return scopeGap.value?.categories ?? [];
});

const monthlyForecasts = computed(() => scopeGap.value?.monthly_forecasts ?? []);

const localUncategorizedForecasts = computed(() => {
  return monthlyForecasts.value.filter((monthlyForecast) => !monthlyForecast.scope_gap_item.scope_gap_category_id).sort(
    (a, b) => a.sort_order - b.sort_order,
  );
});

const localFlatForecasts = computed(() => {
  return monthlyForecasts.value;
});

const hasScopeGapItems = computed(() => monthlyForecasts.value.length > 0);

const showEmptyState = computed(() => {
  return !hasScopeGapItems.value &&
    draftRowKeys.value.length === 0 &&
    draftCategoryKeys.value.length === 0;
});

const canEditMonth = computed(() => {
  return props.canEdit;
  // && DateTime.fromISO(scopeGap.value?.start_date).toFormat('MM-yyyy') === DateTime.now().toFormat('MM-yyyy');
});

const totals = computed(() => {
  const result = {
    finalAmount: 0,
    currentForecast: 0,
    previousForecast: 0,
    variance: 0,
  };

  monthlyForecasts.value.forEach((monthlyForecast) => {
    const previousAmount = monthlyForecast.scope_gap_item.monthly_forecasts[0]?.forecast_amount ?? 0;

    result.finalAmount += monthlyForecast.scope_gap_item.final_amount ?? 0;
    result.currentForecast += monthlyForecast.forecast_amount;
    result.previousForecast += previousAmount;
    result.variance += monthlyForecast.forecast_amount - previousAmount;
  });

  return result;
});

const totalsVarianceClass = computed(() => {
  if(totals.value.variance === 0) return 'text-gray-900';

  return totals.value.variance > 0 ? 'text-red-600' : 'text-green-600';
});

const uncategorizedTotals = computed(() => {
  const result = {
    finalAmount: 0,
    currentForecast: 0,
    previousForecast: 0,
    variance: 0,
  };

  localUncategorizedForecasts.value.forEach((monthlyForecast) => {
    const previousAmount = monthlyForecast.scope_gap_item?.monthly_forecasts?.[0]?.forecast_amount ?? 0;

    result.finalAmount += monthlyForecast.scope_gap_item?.final_amount ?? 0;
    result.currentForecast += monthlyForecast.forecast_amount ?? 0;
    result.previousForecast += previousAmount;
    result.variance += (monthlyForecast.forecast_amount ?? 0) - previousAmount;
  });

  return result;
});

const uncategorizedTotalsVarianceClass = computed(() => {
  if(uncategorizedTotals.value.variance === 0) return 'text-gray-900';

  return uncategorizedTotals.value.variance > 0 ? 'text-red-600' : 'text-green-600';
});

async function onCategorySortEnd(e) {
  const categoryId = e.item.dataset.scopeGapCategoryId;

  await updateCategorySortAction.request(categoryId, {
    sort_order: e.newIndex + 1,
  });
}

async function onItemSortEnd(e) {
  const monthlyForecastId = e.item.dataset.monthlyScopeGapForecastId;

  await updateItemSortAction.request(monthlyForecastId, {
    sort_order: e.newIndex + 1,
  });
}

function addDraftRow() {
  draftRowKeys.value.push(`draft-${++draftKeyCounter}`);

  nextTick(() => {
    emits('draftAdded');
  });
}

function removeDraftRow(key: string) {
  draftRowKeys.value = draftRowKeys.value.filter((draftKey) => draftKey !== key);
}

function addDraftCategoryRow() {
  draftCategoryKeys.value.push(`draft-category-${++draftCategoryKeyCounter}`);

  nextTick(() => {
    emits('draftAdded');
  });
}

function removeDraftCategoryRow(key: string) {
  draftCategoryKeys.value = draftCategoryKeys.value.filter((draftKey) => draftKey !== key);
}

async function onDraftSaved(key: string) {
  removeDraftRow(key);
  await loadData();
}

async function onDraftCategorySaved(key: string) {
  removeDraftCategoryRow(key);
  await loadData();
}

const uncategorizedExpanded = ref(false);
</script>
